// Renders parts that fit the selected vehicle. Reads year/make/model from the
// URL, asks the backend (/apps/turn14?endpoint=parts) for matching handles,
// then fetches each product via Shopify's AJAX API to build cards.
(function () {
  const root = document.querySelector('[data-fitment-results]');
  if (!root) return;

  const grid = root.querySelector('[data-results-grid]');
  const status = root.querySelector('[data-results-status]');
  const empty = root.querySelector('[data-results-empty]');
  const titleEl = root.querySelector('[data-results-title]');

  const q = new URLSearchParams(location.search);
  const year = q.get('year') || '';
  const make = q.get('make') || '';
  const model = q.get('model') || '';

  const label = [year, make, model].filter(Boolean).join(' ');
  if (label) titleEl.textContent = 'Parts for ' + label;

  const money = (cents) => '$' + (cents / 100).toFixed(2);

  async function getJSON(url) {
    const res = await fetch(url, { headers: { Accept: 'application/json' } });
    if (!res.ok) throw new Error('HTTP ' + res.status);
    return res.json();
  }

  function card(p) {
    const li = document.createElement('li');
    li.className = 'one11-card';
    const img = p.featured_image ? p.featured_image : (p.images && p.images[0]) || '';
    li.innerHTML =
      '<a href="/products/' + p.handle + '">' +
      (img ? '<img class="one11-card__img" loading="lazy" src="' + img + '" alt="">' : '<span class="one11-card__img"></span>') +
      '<span class="one11-card__title">' + p.title + '</span>' +
      '<span class="one11-card__price">' + money(p.price) + '</span></a>';
    return li;
  }

  (async () => {
    if (!make) { status.textContent = 'No vehicle selected.'; return; }
    try {
      const data = await getJSON('https://one11-performance.onrender.com/apps/turn14?endpoint=parts&year=' +
        encodeURIComponent(year) + '&make=' + encodeURIComponent(make) +
        '&model=' + encodeURIComponent(model));
      const handles = (data.parts || []).map((p) => p.handle).filter(Boolean);
      if (!handles.length) { status.hidden = true; empty.hidden = false; return; }

      status.textContent = handles.length + ' part' + (handles.length === 1 ? '' : 's') + ' found';
      // fetch product details in parallel batches (was sequential = slow)
      const items = [];
      const BATCH = 10;
      for (let i = 0; i < handles.length; i += BATCH) {
        const batch = handles.slice(i, i + BATCH).map((h) =>
          getJSON('/products/' + h + '.js').catch(() => null));
        const results = await Promise.all(batch);
        results.forEach((p) => { if (p) items.push(p); });
        // render progressively so cards appear as they arrive
        const frag = document.createDocumentFragment();
        results.forEach((p) => { if (p) frag.appendChild(card(p)); });
        grid.appendChild(frag);
      }
      if (!items.length) { status.hidden = true; empty.hidden = false; }
    } catch (e) {
      status.textContent = 'Could not load parts. Please try again or browse all parts.';
    }
  })();
})();
